import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { showPopupParts, setCarItems } from '../../../actions/price'
import { setCarActiveState } from '../../../actions/car'
// import styles
import './car.scss'
import CarPopup from './CarPopup'

import { hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../utils/auth'

// Utils
import { translation } from '../../../utils/helpers'

class Car extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showPopup: false,
      isBodyDepartment: (props.order.OrderType !== 5 &&
        props.order.OrderType !== 1 &&
        (props.addon === 'bodyextent' || props.addon === 'bodyaddon') ||
        (props.order.OrderType === 1 && props.addon === 'bodyaddon')) || props.order.OrderType === 5 && props.addon === 'bodyaddon'
    }
    this.bodyClickEvent = this.bodyClickEvent.bind(this)
  }
  shouldComponentUpdate (nextProps, nextState) {
    let priceChanged = !isEqual(this.props.price, nextProps.price)
    let activeStateChanged = this.props.isCarActive !== nextProps.isCarActive
    return priceChanged || !isEqual(this.props.data, nextProps.data) || !isEqual(this.props.price.CarSize, nextProps.price.CarSize) || activeStateChanged
  }
  componentWillReceiveProps (nextProps) {
  }
  componentDidMount () {
    this.setCarInformation()
    document.addEventListener('carhandler-body-click', this.bodyClickEvent)
    let addon = this.props.addon
    let isBodyDepartment = (this.props.order.OrderType !== 5 &&
      this.props.order.OrderType !== 1 &&
      (addon === 'bodyextent' || addon === 'bodyaddon') ||
      (this.props.order.OrderType === 1 && addon === 'bodyaddon')) || this.props.order.OrderType === 5 && addon === 'bodyaddon'
    // console.log('this.props.order.OrderType', this.props.order.OrderType, 'addon', addon, 'isBodyDepartment', isBodyDepartment)
    this.setState({
      isBodyDepartment: isBodyDepartment
    }, () => {
      // console.log('didmount, setorderdepartment', isBodyDepartment)
    })
    this.props.setCarActiveState(true)
  }
  componentWillUnmount () {
    document.removeEventListener('carhandler-body-click', this.bodyClickEvent)
  }

  componentDidUpdate () {
    this.setCarInformation()
  }

  bodyClickEvent (e) {
    // if (this.props.addon === 'manualbody') {
    //   window.toastr.error(translation('15198'), translation('216'))
    //   return
    // }

    if (((this.props.order.OrderType === 1 && this.props.addon !== '2' && this.props.addon !== 'bodyaddon') || this.props.addon === '3' || this.props.addon === '4' || this.props.price.UseEstimation)) {
      let hasPermission = false
      if (this.props.auth.departmentType === 1 && this.props.price.Department === 0 && this.props.auth.hasPartner) {
        hasPermission = hasPartnerSubscriptionPermission(this.props.auth, 30)
      } else {
        hasPermission = hasSubscriptionPermission(this.props.auth, 30)
      }

      if (!hasPermission) {
        window.toastr.error(translation('2087'), translation('216'))
        return
      }
    }
    let taskSide = 0
    if (e.detail.partType.indexOf('hojre') > -1) taskSide = 2
    if (e.detail.partType.indexOf('venstre') > -1) taskSide = 1
    console.log(e.detail)
    // let parts = this.props.carParts
    // parts = parts.filter(filterCarParts)[0]
    this.props.showPopupParts(true, e.detail.partType, taskSide)
    // if (this.state.isBodyDepartment) {
    //   if (parts.BodyTasks.length > 0) {
    //     this.props.showPopupParts(true, e.detail.partType, taskSide)
    //   } else {
    //     window.toastr.error(translation('14855'), translation('216'))
    //   }
    // } else {
    //   console.log('bodyclick parts', parts)
    //   if (parts.Tasks.length > 0) {
    //     this.props.showPopupParts(true, e.detail.partType, taskSide)
    //   } else {
    //     window.toastr.error(translation('13426'), translation('216'))
    //   }
    // }
  }

  makeCarData (parts) {
    let finalArray = []
    parts.map((val, index) => {
      finalArray[val.Mapping] = []
      val.Tasks.map((task, idx) => {
        finalArray[val.Mapping].push(task)
      })
    })
    return finalArray
  }

  makeSelectedParts (parts) {
    if (typeof parts === 'undefined') {
      return []
    }

    const makePartName = (taskSide, mappingName, id) => {
      let side = ''
      let sideExtra = ''
      switch (taskSide) {
        case 1:
          side = 'venstre-'
          break
        case 2:
          side = 'hojre-'
          break
        case 5:
          side = 'venstre-'
          sideExtra = '-for'
          break
        case 6:
          side = 'hojre-'
          sideExtra = '-for'
          break
        case 7:
          side = 'venstre-'
          sideExtra = '-bag'
          break
        case 8:
          side = 'hojre-'
          sideExtra = '-bag'
          break
      }
      return side + '' + mappingName + sideExtra + '_' + id
    }

    let finalData = []

    if (this.props.addon === '5' || this.props.addon === '6') {
      parts.map((val, index) => {
        val.DeviationReasons.map((v, i) => {
          // console.log('val', val)
          // let side = ''
          // if (v.TaskSide === 1) {
          //   side = 'venstre-'
          // } else if (v.TaskSide === 2) {
          //   side = 'hojre-'
          // }
          // let name = side + '' + val.Part.MappingName + '_' + v.DeviationType.Id

          let name = makePartName(v.TaskSide, val.Part.MappingName, v.DeviationType.Id)

          // let name = makePartName(v.TaskSide, val.Part.MappingName, v.DeviationType.Id)
          finalData.push({
            name: name
          })
        })
        val.CustomDeviationReasons.map((v, i) => {
          // console.log('val', val)
          // let side = ''
          // if (v.TaskSide === 1) {
          //   side = 'venstre-'
          // } else if (v.TaskSide === 2) {
          //   side = 'hojre-'
          // }
          // let name = side + '' + val.Part.MappingName + '_' + v.DeviationType.Id

          let name = makePartName(v.TaskSide, val.Part.MappingName, v.CustomDeviationReasonId)

          // let name = makePartName(v.TaskSide, val.Part.MappingName, v.DeviationType.Id)
          finalData.push({
            name: name
          })
        })
      })
    } else if (this.props.addon === '7') {
      const validOtherDamage = this.props.price.OtherDamages.find(od => !od.Active)
      parts.map(val => {
        val.OtherDamages.map(v => {
          if (validOtherDamage && v.OtherDamageId === validOtherDamage.Id) {
            let name = makePartName(v.TaskSide, val.Part.MappingName, v.Type + '-' + v.Id)

            finalData.push({
              name: name
            })
          }
        })
      })
    } else if ((this.props.order.OrderType === 1 && this.props.addon !== '2' && this.props.addon !== 'bodyaddon') || this.props.addon === '3' || this.props.addon === '4' || this.props.price.UseEstimation) {
      // console.log('ordertype', this.props.order.OrderType, 'addon', this.props.addon, 'price.UseEstimation', this.props.price.UseEstimation)
      parts.map((val, index) => {
        val.EstimationTasks.map((v, i) => {
          /*
          let side = ''
          if (v.TaskSide === 1) {
            side = 'venstre-'
          } else if (v.TaskSide === 2) {
            side = 'hojre-'
          }
          */
          // let name = side + '' + val.Part.MappingName + '_task_' + v.EstimationTaskId
          // let name = side + '' + val.Part.MappingName + '_' + v.EstimationTaskId
          let name = makePartName(v.TaskSide, val.Part.MappingName, v.EstimationTaskId)
          finalData.push({
            name: name
          })
        })
      })
    } else if (this.props.order.OrderType === 5 && this.props.addon !== '2' && this.props.addon !== 'bodyaddon') {
      parts.map((val, index) => {
        val.Complaints.map((v, i) => {
          /*
          let side = ''
          if (v.TaskSide === 1) {
            side = 'venstre-'
          } else if (v.TaskSide === 2) {
            side = 'hojre-'
          }
          let name = side + '' + val.Part.MappingName + '_' + v.ComplaintType
          */
          let name = makePartName(v.TaskSide, val.Part.MappingName, v.ComplaintType)
          finalData.push({
            name: name
          })
        })
      })
    } else {
      parts.map((val, index) => {
        val.Tasks.map((v, i) => {
          if (val.Part.PartItemId === 0) {
            return false
          }
          // if (v.TaskSide === 1) {
          //   side = 'venstre-'
          // } else if (v.TaskSide === 2) {
          //   side = 'hojre-'
          // }
          let taskId = (v.TaskPriceId !== 0) ? v.TaskPriceId : '900000000000000000000'
          let name = makePartName(v.TaskSide, val.Part.MappingName, taskId) // side + '' + val.Part.MappingName + sideExtra + '_' + taskId
          if (v.TaskPriceId === 0) {
            finalData.push({
              name: name,
              value: v.TaskName
            })
          } else {
            finalData.push({
              name: name
            })
          }
        })
      })
    }
    return finalData
  }

  makeInsuranceItems (parts) {
    let finalArray = []
    let finalExtra = []
    parts.map((val, index) => {
      finalArray[val.Mapping] = []
      finalExtra[val.Mapping] = []
      val.EstimationTasks.map((task, idx) => {
        finalArray[val.Mapping].push(task)
      })
      val.EstimationExtra.map((extra, idx) => {
        finalExtra[val.Mapping].push(extra)
      })
    })
    return {
      tasks: finalArray,
      extra: finalExtra
    }
  }

  makeComplaintItems (complaints) {
    let finalArray = []
    complaints.map((val, index) => {
      finalArray.push({
        name: translation(val.DictionaryKey),
        EnumValue: val.EnumValue
      })
    })
    return finalArray
  }

  makeDeviationItems (reasons) {
    let finalArray = []
    Object.keys(reasons).map((val, key) => {
      finalArray.push({
        name: translation(reasons[val]),
        EnumValue: val
      })
    })
    return finalArray
  }

  makeOtherDamageItems (otherDamages) {
    return otherDamages.map(val => {
      return {
        name: translation(val.DictionaryKey),
        EnumValue: val.EnumValue
      }
    })
  }

  setCarInformation () {
    if (Object.keys(this.props.price).length === 0) return null
    // Return false?
    if (this.props.order.OrderType === 5) {
      if (this.props.data.complaints === 0 || typeof this.props.data.complaints === 'undefined') return null
    } else {
      if (this.props.data.parts === 0 || typeof this.props.data.parts === 'undefined') return null
    }

    let carItems = []
    let addon = this.props.addon
    // Get car size
    let size = 'small'
    if (this.props.price.CarSize === 2) {
      size = 'medium'
    } else if (this.props.price.CarSize === 3) {
      size = 'large'
    }

    let orderType = this.props.order.OrderType
    let realOrderType = orderType
    if ((addon === '2' || addon === 'bodyaddon') && orderType === 1) {
      orderType = 3
    }

    if (addon === '3' || this.props.afterEvaluation) {
      orderType = 1
    }

    if (this.props.price.UseEstimation) {
      orderType = 1
    }

    if (addon === '5' || addon === '6' || (this.props.order.OrderType === 5 && (addon === 'bodyextent'))) {
      orderType = 10
    }

    if (orderType === 5 && (addon === '2' || addon === 'bodyaddon')) {
      orderType = 100
    }

    if (addon === 'manual_body') {
      orderType = 20
    }

    if (addon === '7') {
      orderType = 30
    }

    window.carHandler.setPriceCalcType(orderType)
    // console.log('setCarInformation', orderType, this.props.data)
    switch (orderType) {
      case 1:
        carItems = this.makeInsuranceItems(this.props.data.parts)
        carItems.extents = this.props.data.extents
        window.carInnerItems = carItems
        break
      case 5:
        carItems = this.makeComplaintItems(this.props.data.complaints)
        window.carInnerItems = carItems
        break
      case 10:
        carItems = this.makeDeviationItems(this.props.data.reasons)
        // console.log('carItems', carItems)
        window.carInnerItems = carItems
        break
      case 20:
        carItems = null
        break
      case 30:
        carItems = this.makeOtherDamageItems(this.props.data.otherDamages)
        window.carInnerItems = carItems
        break
      default:
        carItems = this.makeCarData(this.props.data.parts)
        window.carInnerItems = carItems
        break
    }
    this.props.setCarItems(carItems)

    window.carHandler.init(size, true)

    window.carHandler.t = translation
    window.carHandler.realOrderType = realOrderType
    window.carHandler.department = this.state.isBodyDepartment === true ? 1 : 0
    // console.log(this.props.order.OrderType, isBodyDepartment === true, window.carHandler.department)

    if (!this.props.order.IsDraft && !this.props.afterEvaluation) {
      window.carHandler.setLocked(true)
    } else {
      window.carHandler.setLocked(false)
    }

    // Shop, unlock car
    if ((this.props.auth.user.UserType === 3 || this.props.auth.user.UserType === 5 || this.props.auth.user.UserType === 6 || this.props.auth.user.UserType === 7) && this.props.price.HasAwaiting === false) {
      window.carHandler.setLocked(false)
    }

    // Lock if after/evaluation
    window.carHandler.setEvaluation(false)
    if (this.props.afterEvaluation || this.props.evaluation) {
      if (this.props.price.ApprovalShop !== 0 && this.props.price.ApprovalShop !== 1) {
        window.carHandler.setLocked(true)
        window.carHandler.setEvaluation(true)
      }
    }

    if (this.props.price.UseEstimation && !this.props.price.IsAfterEvaluation && !this.props.price.IsEvaluation) {
      window.carHandler.setLocked(false)
    }
    // Fill parts
    // console.log('this.props.price.Parts', this.props.price.Parts)
    window.carHandler.selectedParts = this.makeSelectedParts(this.props.price.Parts)
    // console.log('selectedParts', window.carHandler.selectedParts, this.props.price.Parts)
    window.carHandler.fillParts(true)
    // Make header titles
    let headers = {}
    this.props.data.parts.map((part, index) => {
      headers[part.Mapping] = translation(part.DictionaryKey)
    })
    window.carHandler.headers = headers
  }

  render () {
    let disabled = false
    if (this.props.addon === 'manualbody') {
      disabled = true
    }

    if (Object.keys(this.props.price).length === 0) return null
    // Is car size set?
    if (this.props.price.CarSize === 0) return null
    // Return false?
    if (this.props.order.OrderType === 5) {
      if (this.props.data.complaints === 0 || typeof this.props.data.complaints === 'undefined') return null
    } else {
      if (this.props.data.parts === 0 || typeof this.props.data.parts === 'undefined') return null
    }

    let classes = 'car_container'
    let onDisabledClick = null
    let forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1 // Forsi is available for the company
    let translationKey = forsiEnable ? '15198' : '18042'
    if (!this.props.isCarActive || disabled) {
      classes += ' car_container_disabled'
      onDisabledClick = () => {
        window.toastr.error(translation(translationKey), translation('216'))
      }
    }

    // Render
    return (
      <div className={classes} onClick={onDisabledClick}>
        <div id='wsp_damage_svg_cont' />
        {/* disabled && <div className='carPopupWrapper1' ><div className='carPopupBackdrop disabled_overlay'></div></div> */}
        {!disabled && <CarPopup show={this.props.showPopupForParts} isPaint={!this.state.isBodyDepartment} addon={this.props.addon} />}
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    price: state.price.price,
    order: state.orders.order,
    carParts: state.price.carParts,
    showPopupForParts: state.price.showPopupForParts,
    isCarActive: state.car.isActive
  }
}

export default connect(mapStateToProps, {
  showPopupParts,
  setCarItems,
  setCarActiveState
})(Car)



// WEBPACK FOOTER //
// ./src/app/shared/components/Car/index.js